import React from "react";
import "./ProgressBar.css";

/**
 * Barra de progresso com rótulo e percentual.
 * @param {number} value 0–100
 * @param {string} [label] texto acima da barra (ex: "Enviando 3 de 30")
 * @param {string} [detail] texto menor abaixo (ex: item atual)
 */
const ProgressBar = ({ value = 0, label, detail, className = "" }) => {
  const percent = Math.max(0, Math.min(100, Math.round(Number(value) || 0)));
  return (
    <div className={`progress-bar ${className}`.trim()}>
      <div className="progress-bar__header">
        {label && <span className="progress-bar__label">{label}</span>}
        <span className="progress-bar__percent">{percent}%</span>
      </div>
      <div
        className="progress-bar__track"
        role="progressbar"
        aria-valuenow={percent}
        aria-valuemin={0}
        aria-valuemax={100}
        aria-label={label}
      >
        <div className="progress-bar__fill" style={{ width: `${percent}%` }} />
      </div>
      {detail && <span className="progress-bar__detail">{detail}</span>}
    </div>
  );
};

export default ProgressBar;
